import { cowFeed, huggingMachine } from './items'

const inventory = [cowFeed, huggingMachine]

export default inventory
